export const FORWARD_SHORTCUT_SECONDS = 5;
export const BACKWARD_SHORTCUT_SECONDS = 5;
export const RAISE_VOLUME_PERCENT = 10;
export const REDUCE_VOLUME_PERCENT = 10;
